import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout/Layout';
import Home from './components/Home/Home';
import About from './components/About/About';
import SvgBackground from './components/SvgBackground/SvgBackground';
import { useLanguage } from './context/LanguageContext';
import Partner from "./components/Partner/Partner";
import ContactUs from "./components/ContactUs/ContactUs";

import TeamSection from "./components/Team/TeamSection";
import FloatingLanguageSwitcher from "./components/LangSwitcher/FloatingLanguageSwitcher";
import AnalyticsDashboard from './components/Admin/AnalyticsDashboard';
import Shop from './components/Shop/Shop';
import FloatingAcademyShopButton from './components/FloatingAcademyShopButton/FloatingAcademyShopButton';
import ProductDetail from './components/Shop/ProductDetail';
import ShopBackOffice from './components/Shop/ShopBackOffice';
import ShopLayout from './components/Shop/ShopLayout';
import ScrollToTop from './components/Layout/ScrollToTop';
import './components/Shop/ShopWrapper.css';
import { Analytics, track } from "@vercel/analytics/react";

import FloatingCoursesButton from './components/FloatingCoursesButton/FloatingCoursesButton';

const App: React.FC = () => {
  const { language, direction } = useLanguage();

  // Track page visit with language preference
  useEffect(() => {
    // Track initial page load with language preference
    track('page_view', {
      language,
      direction,
      url: window.location.pathname,
      referrer: document.referrer || 'direct',
      screen_width: window.innerWidth,
      user_agent: navigator.userAgent,
      timestamp: new Date().toISOString()
    });
  }, [language, direction]);

  return (
    <HelmetProvider>
      <Router>
        {/* Add ScrollToTop component to handle scrolling on route changes */}
        <ScrollToTop />

        <div className="App" dir={direction} lang={language}>
          <Routes>
            {/* Shop Routes */}
            <Route path="/shop" element={
              <ShopLayout>
                <Shop />
              </ShopLayout>
            } />

            {/* Product Detail Route */}
            <Route path="/shop/product/:id" element={
              <ShopLayout>
                <ProductDetail />
              </ShopLayout>
            } />

            <Route path="/shop/management1" element={
              <ShopLayout>
                <div className="shop-admin-wrapper">
                  <ShopBackOffice />
                </div>
              </ShopLayout>
            } />

            {/* Admin Analytics Route */}
            <Route path="/admin/analytics" element={
              <AnalyticsDashboard />
            } />

            {/* Main Home Route */}
            <Route path="/" element={
              <>
                <SvgBackground />
                <FloatingLanguageSwitcher />
                {/* Summer Button - Only on Home Page */}

                 <FloatingCoursesButton />
                 <FloatingAcademyShopButton />
                <Layout>
                  {/* Vercel Analytics */}
                  <Analytics debug={process.env.NODE_ENV === 'development'} />

                  <Home />
                  <About />
                  <TeamSection />

                  <Partner />
                  <ContactUs />
                </Layout>
              </>
            } />
          </Routes>
        </div>
      </Router>
    </HelmetProvider>
  );
};

export default App;